<div
  class="dialog-main__container"
  [class]="isMobilization ? 'mobilization-block' : 'sabbatical-block'"
>
  <div class="dialog-header__container">
    <h3 class="dialog-header__title">
      {{ isCreate ? 'New long-term leave' : 'Edit long-term leave' }}
    </h3>
  </div>

  <div class="dialog-content__container">
    <form [formGroup]="longTermLeaveForm">
      <div class="sabbatical">
        <div class="form__item row">
          <label
            class="col-5 d-flex align-items-center"
            appMarkAsterisk
            [formGroup]="longTermLeaveForm"
            [controlName]="'longTermLeaveType'"
            [touched]="formControl('longTermLeaveType')!.touched"
            >Type</label
          >
          <div class="col-6" [class.pl-0]="!isCreate">
            <app-dropdown
              formControlName="longTermLeaveType"
              [items]="longTermLeaveTypes"
              [border]="isCreate ? 'classic' : 'none'"
              [disabl]="!isCreate"
              [isEditMode]="isCreate"
            ></app-dropdown>
          </div>
        </div>
        <div class="row align-items-center">
          <label
            class="label-input col-5"
            appMarkAsterisk
            [formGroup]="longTermLeaveForm"
            [controlName]="'startDate'"
            [touched]="formControl('startDate')!.touched"
            >Start date
          </label>
          <app-datepicker
            class="col-6"
            [iconLeft]="true"
            formControlName="startDate"
            [staticPropery]="true"
            (datepickerOpened)="isDatePickerOpened = $event"
          >
          </app-datepicker>
        </div>
        <div *ngIf="!isCreate" class="row align-items-center form-validation">
          <label
            class="label-input col-5"
            appMarkAsterisk
            [formGroup]="longTermLeaveForm"
            [controlName]="'endDate'"
            [touched]="formControl('endDate')!.touched"
            >End date
          </label>
          <app-datepicker
            class="col-6"
            [iconLeft]="true"
            formControlName="endDate"
            [deadLine]="isoStartDate"
            [disabl]="!startDate.value"
            [staticPropery]="true"
            (datepickerOpened)="isDatePickerOpened = $event"
          >
          </app-datepicker>
          <app-error-field
          [displayError]="longTermLeaveForm.hasError('invalidDate')"
          [errorMessage]="'End date should be greater than start date'" >
        </app-error-field>
        </div>
        <ng-container *ngIf="isMobilization" formGroupName="mobilization">
          <div class="form__item row" [class.zero-index]="isDatePickerOpened">
            <label
              class="col-5 d-flex align-items-center"
              appMarkAsterisk
              [formGroup]="mobilizationForm"
              [controlName]="'createdBy'"
              [touched]="mobilizationFormControl('createdBy')!.touched"
              >Created By</label
            >
            <div class="col-6" [class.pl-0]="isMobilizationFieldsDisabled">
              <app-dropdown
                formControlName="createdBy"
                [isMultiselect]="false"
                [items]="data.createdByOptionList"
                [border]="isMobilizationFieldsDisabled ? 'none': 'classic'"
                [disabl]="isMobilizationFieldsDisabled"
                [isEditMode]="!isMobilizationFieldsDisabled"
              ></app-dropdown>
            </div>
          </div>
          <div
            class="form__item row mb-3"
            [class.zero-index]="isDatePickerOpened"
          >
            <label
              class="col-5 d-flex align-items-center"
              appMarkAsterisk
              [formGroup]="mobilizationForm"
              [controlName]="'corporateAccount'"
              [touched]="mobilizationFormControl('corporateAccount')!.touched"
              >Corporate account Block</label
            >
            <div [class]="isAccountBlockDate ? 'col-4' : 'col-6'" [class.pl-0]="isMobilizationFieldsDisabled">
              <app-dropdown
                formControlName="corporateAccount"
                [items]="corporateAccountOptionsList"
                [border]="isMobilizationFieldsDisabled ? 'none': 'classic'"
                [disabl]="isMobilizationFieldsDisabled"
                [isEditMode]="!isMobilizationFieldsDisabled"
              ></app-dropdown>
            </div>
            <div
              *ngIf="isAccountBlockDate"
              class="col-sm-3 d-flex align-items-center"
            >
              <label
                class="col-sm-3 d-flex align-items-center"
                appMarkAsterisk
                [formGroup]="mobilizationForm"
                [controlName]="'accountBlockDate'"
                [touched]="mobilizationFormControl('accountBlockDate')!.touched"
                >Date</label
              >
              <fieldset [disabled]="isMobilizationFieldsDisabled" class="form__fieldset">
              <app-datepicker
                [iconLeft]="true"
                formControlName="accountBlockDate"
                [disabl]="isMobilizationFieldsDisabled"
              ></app-datepicker>
            </fieldset>
            </div>
          </div>
          <div
          class="form__item row mb-3"
          [class.zero-index]="isDatePickerOpened"
        >
          <label
            class="col-5 d-flex align-items-center"
            appMarkAsterisk
            [formGroup]="mobilizationForm"
            [controlName]="'accountCorrespondence'"
            [touched]="mobilizationFormControl('accountCorrespondence')!.touched"
            >Account Correspondence</label
          >
          <div class="col-6" [class.pl-0]="isMobilizationFieldsDisabled">
            <app-dropdown
              formControlName="accountCorrespondence"
              [items]="accountCorrespondenceOptionList"
              [border]="isMobilizationFieldsDisabled ? 'none': 'classic'"
              [disabl]="isMobilizationFieldsDisabled"
              [isEditMode]="!isMobilizationFieldsDisabled"
            ></app-dropdown>
          </div>
        </div>
          <div
            class="form__item row mb-3"
            [class.zero-index]="isDatePickerOpened"
          >
            <label
              class="col-5 d-flex align-items-center"
              appMarkAsterisk
              [formGroup]="mobilizationForm"
              [controlName]="'equipment'"
              [touched]="mobilizationFormControl('equipment')!.touched"
              >Equipment</label
            >
            <div class="col-6" [class.pl-0]="isMobilizationFieldsDisabled">
              <app-dropdown
                formControlName="equipment"
                [items]="equipmentOptionsList"
                [border]="isMobilizationFieldsDisabled ? 'none': 'classic'"
                [disabl]="isMobilizationFieldsDisabled"
                [isEditMode]="!isMobilizationFieldsDisabled"
              ></app-dropdown>
            </div>
          </div>

          <ng-container formGroupName="emergencyContactPerson">
            <div class="form__item row" [class.zero-index]="isDatePickerOpened">
              <label
                class="label-input col-5"
                appMarkAsterisk
                [formGroup]="contactPerson"
                [controlName]="'name'"
                [touched]="contactPerson.get('name')!.touched"
                >Emergency contact person (relationship&name)</label
              >
              <div class="d-flex col-sm-6">
                <app-dropdown
                  class="col-5"
                  [items]="relationships"
                  formControlName="relationship"
                ></app-dropdown>
                <input
                  type="text"
                  class="input__basic relationship ml-16"
                  placeholder=" "
                  formControlName="name"
                />
                <app-error-field
                  [displayError]="
                    contactPerson.get('name')!.hasError('maxlength')
                  "
                  [errorMessage]="'Max field length = 40'"
                ></app-error-field>
              </div>
            </div>

            <div class="form__item row">
              <label
                class="label-input col-5"
                appMarkAsterisk
                [formGroup]="contactPerson"
                [controlName]="'phoneNumber'"
                [touched]="contactPerson.get('phoneNumber')!.touched"
                >Emergency contact person phone number</label
              >

              <div class="input__wrapper col-6">
                <input
                  type="text"
                  class="input__basic"
                  placeholder=" "
                  formControlName="phoneNumber"
                  [mask]="phoneMask"
                  [patterns]="phonePatterns"
                />
              </div>
            </div>
          </ng-container>
        </ng-container>

        <div class="row align-items-center">
          <label
            class="label-input col-5"
            appMarkAsterisk
            [formGroup]="longTermLeaveForm"
            [controlName]="'comment'"
            [touched]="formControl('comment')!.touched"
            >Comment</label
          >
          <div class="col-6 input__wrapper">
            <input
              type="text"
              class="input__basic"
              placeholder=" "
              formControlName="comment"
            />
            <app-error-field
              [displayError]="formControl('comment')!.hasError('wordCount')"
              [errorMessage]="'Max field length = 400 words'"
            ></app-error-field>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="row justify-content-end dialog-button__container pt-3">
    <div class="col-auto p-0">
      <button class="button button__save add-margin" (click)="save()">
        Save
      </button>
      <button class="button button__cancel" (click)="cancel()">Cancel</button>
    </div>
  </div>
</div>
